import api from "./api"

export type SupportedLanguage = "tr" | "en"
export const SUPPORTED_LANGUAGES: { code: SupportedLanguage; label: string }[] = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
]

const LANGUAGE_KEY = "audex_language"

export function getStoredLanguage(): SupportedLanguage {
  const stored = localStorage.getItem(LANGUAGE_KEY)
  if (stored === "en" || stored === "tr") return stored
  // Browser default
  const browserLang = navigator.language.substring(0, 2)
  return browserLang === "tr" ? "tr" : "en"
}

export function setStoredLanguage(lang: SupportedLanguage) {
  localStorage.setItem(LANGUAGE_KEY, lang)
}

export async function fetchTranslations(language: SupportedLanguage): Promise<Record<string, string>> {
  const { data } = await api.get<Record<string, string>>("/i18n/translations", {
    params: { language },
  })
  return data
}

export interface TranslationEntry {
  key: string
  value: string
}

export async function upsertTranslation(key: string, language: SupportedLanguage, value: string) {
  const { data } = await api.post("/i18n/translations", { key, language, value })
  return data
}

export async function reloadTranslations() {
  const { data } = await api.post("/i18n/reload")
  return data
}
